import React, { Component } from 'react'
import PolicyTerms from './PolicyTerms'
import history from "../../route/history";

const prePage = (e) => {
  e.preventDefault();
  history.goBack();
}

class Terms extends Component {
  
  
  render() {
    return (
      <React.Fragment>
        <div id="contents">
          <div className="content-header">
            <a href="#" onClick={prePage} className="page-prev">뒤로이동</a>{/* <!-- mobile --> */}     
            <h2>이용약관</h2>
            <div className="breadcrumb">
              <span>Home</span><span>고객센터</span><em>이용약관</em>
            </div>
          </div>

            <section>
              <PolicyTerms />
            </section>

        </div>
      </React.Fragment>
    )
  }
}

export default Terms
